import {CommonDropDown, CommonProps} from '@hconnect/common/components/shiftEventFormFields'
import {WorkOrderEventStatus, eventStatusListWorkOrder} from '@hconnect/common/types'
import {EventStatusLabel} from '@widgets/common-shift-event'
import React from 'react'

export const WorkOrderStatusDropDown = (
  props: CommonProps<WorkOrderEventStatus>
): React.ReactElement => {
  return (
    <CommonDropDown<WorkOrderEventStatus>
      {...props}
      required
      keyName="status"
      options={eventStatusListWorkOrder}
      customTemplate={(status) => {
        return <EventStatusLabel status={status} />
      }}
    />
  )
}
